import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  header: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: theme.spacing(2)
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 0
  },
  contentContainer: { textAlign: 'center', padding: '3px' },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(3)
  },
  labelText: {
    marginBottom: theme.spacing(1),
    textAlign: 'center'
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  listButtonContainer: {
    display: 'flex',
    flexDirection: 'column', // Cambiado de 'row' a 'column' para alinearlos verticalmente
    gap: theme.spacing(2), // Mantener el espacio entre los botones
    width: '100%'
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`
  },
  expandButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '100%'
  },
  listContainer: {
    marginTop: theme.spacing(2),
    maxHeight: '200px',
    overflowY: 'auto'
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(2),
    backgroundColor: '#f5f5f5', // Light gray background for depth
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1)
  },
  greenText: {
    color: '#5C8E2F' // Slightly darker green for better contrast
  },
  skuList: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1]
  }
}))
